import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import './Pages.css';

export const TermsOfUse: React.FC = () => {
  return (
    <div className="ns-legal-page">
      <header className="ns-legal-header">
        <div className="ns-legal-header-content">
          <Link to="/" className="ns-legal-logo">
            <span className="mark">NS</span>
            <span className="text">NutriSync</span>
          </Link>
          <Link to="/">
            <Button variant="secondary">Voltar ao início</Button>
          </Link>
        </div>
      </header>

      <main className="ns-legal-main">
        <div className="ns-legal-container">
          <h1>Termos de Uso</h1>
          <p className="ns-legal-intro">
            Estes Termos de Uso regulam o uso da plataforma NutriSync. 
            Ao utilizar nossos serviços, você concorda com estes termos.
          </p>
          <p className="ns-legal-updated">
            <strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-BR')}
          </p>

          <section className="ns-legal-section">
            <h2>1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e utilizar a plataforma NutriSync, você concorda em cumprir e estar 
              vinculado a estes Termos de Uso. Se você não concorda com qualquer parte destes 
              termos, não deve utilizar nossos serviços.
            </p>
            <p>
              Estes termos constituem um acordo legal entre você e o NutriSync. Recomendamos 
              que leia atentamente este documento antes de utilizar a plataforma.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>2. Definições</h2>
            <ul className="ns-legal-list">
              <li>
                <strong>"Plataforma" ou "Serviço":</strong> Refere-se ao NutriSync, incluindo 
                o painel web e aplicativo mobile.
              </li>
              <li>
                <strong>"Usuário" ou "Você":</strong> Refere-se à pessoa física ou jurídica 
                que utiliza a plataforma.
              </li>
              <li>
                <strong>"Nutricionista":</strong> Profissional cadastrado que utiliza a 
                plataforma para gerenciar pacientes e serviços nutricionais.
              </li>
              <li>
                <strong>"Paciente":</strong> Pessoa cujos dados são gerenciados pelo 
                nutricionista através da plataforma.
              </li>
              <li>
                <strong>"Conteúdo":</strong> Todas as informações, dados, textos, imagens 
                e outros materiais disponibilizados na plataforma.
              </li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>3. Cadastro e Conta</h2>
            <h3>3.1. Requisitos para Cadastro</h3>
            <p>Para utilizar a plataforma, você deve:</p>
            <ul className="ns-legal-list">
              <li>Ter pelo menos 18 anos de idade</li>
              <li>Ser nutricionista registrado no Conselho Regional de Nutricionistas (CRN)</li>
              <li>Fornecer informações precisas e atualizadas</li>
              <li>Manter a segurança de sua conta e senha</li>
              <li>Ser responsável por todas as atividades em sua conta</li>
            </ul>

            <h3>3.2. Responsabilidades do Usuário</h3>
            <p>Você é responsável por:</p>
            <ul className="ns-legal-list">
              <li>Manter a confidencialidade de sua senha</li>
              <li>Notificar imediatamente sobre uso não autorizado de sua conta</li>
              <li>Garantir que todas as informações fornecidas sejam verdadeiras e precisas</li>
              <li>Atualizar suas informações quando necessário</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>4. Uso da Plataforma</h2>
            <h3>4.1. Uso Permitido</h3>
            <p>Você pode utilizar a plataforma para:</p>
            <ul className="ns-legal-list">
              <li>Gerenciar seus pacientes e suas informações de saúde</li>
              <li>Criar e gerenciar planos alimentares</li>
              <li>Agendar e gerenciar consultas</li>
              <li>Comunicar-se com seus pacientes</li>
              <li>Gerar relatórios e análises</li>
              <li>Realizar cálculos nutricionais</li>
            </ul>

            <h3>4.2. Uso Proibido</h3>
            <p>É expressamente proibido:</p>
            <ul className="ns-legal-list">
              <li>Utilizar a plataforma para fins ilegais ou não autorizados</li>
              <li>Tentar acessar áreas restritas da plataforma sem autorização</li>
              <li>Interferir ou interromper o funcionamento da plataforma</li>
              <li>Transmitir vírus, malware ou código malicioso</li>
              <li>Copiar, modificar ou distribuir o conteúdo sem autorização</li>
              <li>Utilizar a plataforma para spam ou atividades fraudulentas</li>
              <li>Violar direitos de propriedade intelectual</li>
              <li>Compartilhar sua conta com terceiros</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>5. Dados e Privacidade</h2>
            <p>
              O tratamento de dados pessoais é regido pela nossa Política de Privacidade e 
              pela Lei Geral de Proteção de Dados (LGPD). Ao utilizar a plataforma, você 
              concorda com a coleta, uso e armazenamento de dados conforme descrito em nossa 
              Política de Privacidade.
            </p>
            <p>
              Você é responsável por garantir que possui autorização adequada para inserir 
              dados de pacientes na plataforma e que está em conformidade com todas as leis 
              aplicáveis de proteção de dados.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>6. Assinatura e Pagamento</h2>
            <h3>6.1. Período de Teste</h3>
            <p>
              Oferecemos um período de teste grátis de 7 dias. Durante este período, você 
              tem acesso completo a todas as funcionalidades sem custo.
            </p>

            <h3>6.2. Assinatura</h3>
            <p>
              Após o período de teste, a assinatura é renovada automaticamente mensalmente 
              pelo valor de R$ 49,90, a menos que você cancele antes do término do período.
            </p>

            <h3>6.3. Pagamento</h3>
            <p>
              Os pagamentos são processados através de provedores terceirizados seguros. 
              Você autoriza o débito automático na forma de pagamento cadastrada.
            </p>

            <h3>6.4. Cancelamento</h3>
            <p>
              Você pode cancelar sua assinatura a qualquer momento através das configurações 
              da sua conta. O cancelamento entrará em vigor no final do período pago.
            </p>

            <h3>6.5. Reembolsos</h3>
            <p>
              Reembolsos são avaliados caso a caso. Em geral, não oferecemos reembolso para 
              períodos já utilizados, exceto em casos de erro técnico de nossa parte.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>7. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo da plataforma, incluindo design, textos, gráficos, logos, 
              ícones e software, é propriedade do NutriSync ou de seus licenciadores e está 
              protegido por leis de direitos autorais e outras leis de propriedade intelectual.
            </p>
            <p>
              Você recebe uma licença limitada, não exclusiva e não transferível para utilizar 
              a plataforma conforme estes termos. Esta licença não inclui o direito de:
            </p>
            <ul className="ns-legal-list">
              <li>Reproduzir, modificar ou criar obras derivadas</li>
              <li>Distribuir, sublicenciar ou transferir a plataforma</li>
              <li>Fazer engenharia reversa ou descompilar o software</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>8. Conteúdo do Usuário</h2>
            <p>
              Você mantém todos os direitos sobre o conteúdo que você cria ou envia através 
              da plataforma. Ao utilizar a plataforma, você concede ao NutriSync uma licença 
              não exclusiva para usar, armazenar e processar seu conteúdo para fornecer os 
              serviços.
            </p>
            <p>
              Você garante que possui todos os direitos necessários sobre o conteúdo que 
              envia e que não viola direitos de terceiros.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>9. Disponibilidade do Serviço</h2>
            <p>
              Nos esforçamos para manter a plataforma disponível 24/7, mas não garantimos 
              disponibilidade ininterrupta. Podemos realizar manutenções programadas ou de 
              emergência que podem resultar em indisponibilidade temporária.
            </p>
            <p>
              Não nos responsabilizamos por perdas ou danos resultantes de indisponibilidade 
              da plataforma, exceto quando causada por negligência grosseira ou dolo.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>10. Limitação de Responsabilidade</h2>
            <p>
              O NutriSync é fornecido "como está" e "conforme disponível". Não garantimos que 
              a plataforma atenderá a todos os seus requisitos ou estará livre de erros.
            </p>
            <p>
              Em nenhuma circunstância seremos responsáveis por danos indiretos, incidentais, 
              especiais ou consequenciais, incluindo perda de lucros, dados ou oportunidades de 
              negócio.
            </p>
            <p>
              Nossa responsabilidade total não excederá o valor pago por você nos últimos 
              12 meses pela assinatura.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>11. Indenização</h2>
            <p>
              Você concorda em indenizar e isentar o NutriSync, seus diretores, funcionários 
              e parceiros de qualquer reclamação, dano, perda, responsabilidade e despesa 
              (incluindo honorários advocatícios) decorrentes de:
            </p>
            <ul className="ns-legal-list">
              <li>Seu uso da plataforma</li>
              <li>Violação destes Termos de Uso</li>
              <li>Violação de direitos de terceiros</li>
              <li>Conteúdo que você envia ou transmite através da plataforma</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>12. Modificações dos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. 
              Alterações significativas serão comunicadas através de e-mail ou aviso na 
              plataforma.
            </p>
            <p>
              O uso continuado da plataforma após as modificações constitui aceitação dos 
              novos termos. Se você não concordar com as modificações, deve cancelar sua 
              assinatura e parar de usar a plataforma.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>13. Rescisão</h2>
            <p>
              Podemos suspender ou encerrar sua conta imediatamente, sem aviso prévio, se 
              você violar estes Termos de Uso ou se houver suspeita de atividade fraudulenta.
            </p>
            <p>
              Você pode encerrar sua conta a qualquer momento através das configurações ou 
              entrando em contato conosco.
            </p>
            <p>
              Após o encerramento, seus dados serão mantidos conforme nossa Política de 
              Privacidade e requisitos legais.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>14. Lei Aplicável e Foro</h2>
            <p>
              Estes Termos de Uso são regidos pelas leis brasileiras. Qualquer disputa 
              será resolvida no foro da comarca de São Paulo, SP, renunciando as partes 
              a qualquer outro, por mais privilegiado que seja.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>15. Disposições Gerais</h2>
            <p>
              Se qualquer disposição destes termos for considerada inválida ou inexequível, 
              as demais disposições permanecerão em pleno vigor.
            </p>
            <p>
              Estes termos constituem o acordo completo entre você e o NutriSync em relação 
              ao uso da plataforma.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>16. Contato</h2>
            <p>Para questões sobre estes Termos de Uso, entre em contato:</p>
            <div className="ns-contact-info">
              <p><strong>NutriSync</strong></p>
              <p>E-mail: legal@nutrisync.com.br</p>
              <p>Telefone: (11) 0000-0000</p>
            </div>
          </section>

          <div className="ns-legal-footer-actions">
            <Link to="/">
              <Button>Voltar ao início</Button>
            </Link>
            <Link to="/privacidade">
              <Button variant="secondary">Ver Política de Privacidade</Button>
            </Link>
            <Link to="/lgpd">
              <Button variant="secondary">Ver LGPD</Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

